<template>
    <lv-column-text
                    :align="align"
                    :link="link"
                    :row="showRow"
                    :row-index="rowIndex"
                    :field="field"
                    :editable="lv_editable"
                    :data-type="dataType"
                    :tooltip="tooltip">
        <slot :row="row" :rowIndex="rowIndex" :align="align" :field="field" :editable="lv_editable">
            <link-toggle
                v-if="!fixedRow"
                :value="showRow[field]"
                :true-value="trueValue"
                :false-value="falseValue"
                @input="val=>$set(showRow,field,val)"
                :size="size"
                :color="color"
                :disabled="!lv_editable"/>
        </slot>
    </lv-column-text>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LinkToggle from "../../toggle/link-toggle";
    import LvColumnText from "../lv-column-text";

    export default {
        name: 'link-table-column-toggle-item',
        components: {LvColumnText, LinkToggle},
        mixins: [ColumnItemMixin],
        data() {
            return {}
        },
        props: {
            size: {default: 'small'},
            color: {default: 'primary',},

            trueValue: {default: 'Y'},
            falseValue: {default: 'N'},
        },
    };
</script>
